import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Component } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { defaultFormula } from './utils'; // TODO: look into measureText function that uses canvas measurer to collect widths faster, should be able to accept an array
// possibly have const { measureRef, measureText } = measure(id), measureText(txt) | measureText([txt,txt,txt])

var Measure = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Measure, _Component);

  function Measure() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "firstResizeEvent", true);

    _defineProperty(_assertThisInitialized(_this), "storingMeasurements", false);

    _defineProperty(_assertThisInitialized(_this), "nodes", {});

    _defineProperty(_assertThisInitialized(_this), "formulas", {});

    _defineProperty(_assertThisInitialized(_this), "refsById", {});

    _defineProperty(_assertThisInitialized(_this), "measurements", null);

    _defineProperty(_assertThisInitialized(_this), "measureRef", function (id, _temp) {
      var _ref = _temp === void 0 ? {} : _temp,
          _ref$formula = _ref.formula,
          formula = _ref$formula === void 0 ? defaultFormula : _ref$formula,
          innerRef = _ref.innerRef;

      if (!_this.refsById[id]) {
        _this.refsById[id] = function (node) {
          var previousStoredNode = _this.nodes[id];

          if (node) {
            // store id on node so we can retrieve formula and store new
            // measurements in ResizeObserver callback
            node.__measureId = id;
            _this.nodes[id] = node;
            _this.formulas[id] = formula;

            _this.resizeObserver.observe(node);
          } else if (previousStoredNode) {
            _this.resizeObserver.unobserve(previousStoredNode);

            delete _this.formulas[id];
            delete _this.nodes[id];
            delete _this.measurements[id];
          } // allow other libraries to interop with node


          if (innerRef) {
            innerRef(node);
          }
        };
      }

      return _this.refsById[id];
    });

    _defineProperty(_assertThisInitialized(_this), "getMeasurements", function () {
      return Object.keys(_this.nodes).reduce(function (measurements, key) {
        var _objectSpread2;

        var node = _this.nodes[key];
        var formula = _this.formulas[key];
        return _objectSpread(_objectSpread({}, measurements), {}, (_objectSpread2 = {}, _objectSpread2[key] = formula(node), _objectSpread2));
      }, {});
    });

    _defineProperty(_assertThisInitialized(_this), "resizeObserver", new ResizeObserver(function (entries) {
      if (_this.firstResizeEvent) {
        _this.firstResizeEvent = false;
      } else {
        var measurements = _objectSpread({}, _this.measurements);

        entries.forEach(function (entry) {
          var id = entry.target.__measureId;
          var node = _this.nodes[id];
          var formula = _this.formulas[id];

          if (formula) {
            measurements[id] = formula(node);
          }
        });
        _this.measurements = measurements;

        if (_this.props.updateOnMeasure) {
          _this.forceUpdate();
        }

        if (_this.props.onMeasure) {
          _this.props.onMeasure(measurements, _this.nodes);
        }
      }
    }));

    return _this;
  }

  var _proto = Measure.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.updateOnMeasure || this.props.onMeasure) {
      this.updateMeasurements();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  };

  _proto.updateMeasurements = function updateMeasurements() {
    var measurements = this.getMeasurements();
    this.measurements = measurements;

    if (this.props.updateOnMeasure) {
      this.forceUpdate();
    }

    if (this.props.onMeasure) {
      this.props.onMeasure(measurements, this.nodes);
    }
  };

  _proto.render = function render() {
    return this.props.children({
      measureRef: this.measureRef,
      measurements: this.measurements,
      getMeasurements: this.getMeasurements
    });
  };

  return Measure;
}(Component);

_defineProperty(Measure, "defaultProps", {
  updateOnMeasure: true
});

export default Measure;